import { render } from "./JavascriptException.vue?vue&type=template&id=239b045c"
import script from "./JavascriptException.vue?vue&type=script&lang=js"
export * from "./JavascriptException.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__